import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from './api.service';
import { Market } from 'src/app/storage/models/market.model';
import { IMarket } from 'src/app/storage/interfaces/market.interface';
import { StorageService } from './storage.service';
import { CONSTANTS } from 'src/app/constants';
import { BehaviorSubject } from 'rxjs';

const URL = environment.aws.amplify.API.REST;

@Injectable({
  providedIn: 'root'
})
export class MarketService {

  markets$: BehaviorSubject<Market[] | null> = new BehaviorSubject<Market[] | null>(null);
  selectedMarket$: BehaviorSubject<Market | null> = new BehaviorSubject<Market | null>(null);

  constructor(
    private translateService: TranslateService,
    private apiService: ApiService,
    private storageService: StorageService
  ) { }

  async getMarkets(): Promise<void> {
    const translations = await this.translateService.get('MARKETS').toPromise();

    const response = await this.apiService.get(
      `${URL}markets/`,
      translations['LABEL'],
      { showLoader: true }
    );

    const markets = response ? response.markets.map((market: IMarket) => new Market(market)) : null;
    this.markets$.next(markets);
  }

  setDefaultMarketname(marketname: string): void {
    this.storageService.setData(CONSTANTS.STORAGE.MARKET, marketname);
  }

  getDefaultMarketname(): string {
    let marketname = this.storageService.getData(CONSTANTS.STORAGE.MARKET);
    return marketname ? marketname : CONSTANTS.REGIONS.EUROPE_MIDDLEEAST;
  }
}